var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"ml-1",attrs:{"outlined":"","color":"primary"},on:{"click":_vm.reloadTable}},[_c('i',{staticClass:"v-icon notranslate material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("sync")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }